import { render, staticRenderFns } from "./data-processing-card.vue?vue&type=template&id=4143037e&scoped=true"
import script from "./data-processing-card.vue?vue&type=script&lang=js"
export * from "./data-processing-card.vue?vue&type=script&lang=js"
import style0 from "./data-processing-card.vue?vue&type=style&index=0&id=4143037e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4143037e",
  null
  
)

export default component.exports